/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/close-otg-black': {
    width: 13,
    height: 13,
    viewBox: '0 0 13 13',
    data: '<g clip-path="url(#clip0_4137_1515)" _stroke="#000" stroke-width="2" stroke-linecap="square"><path pid="0" d="M1.5 1.5l10 10M11.5 1.5l-10 10"/></g><defs><clipPath id="clip0_4137_1515"><path pid="1" _fill="#fff" transform="translate(.1 .1)" d="M0 0h12.8v12.8H0z"/></clipPath></defs>'
  }
})
